import React from 'react'

import { MobileStepper } from '@material-ui/core'

import useSupplierJourney from 'hooks/useSupplierJourney'

const Stepper = () => {
  const { activeStep, steps, linkInvalid } = useSupplierJourney()

  if (linkInvalid) return null

  return (
    <MobileStepper
      variant="dots"
      steps={steps.length}
      position="static"
      activeStep={activeStep}
    />
  )
}

export default Stepper
